module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a179def1e7266cfec58e468b70457ca0.png";